export function parseApiPayload(payload) {
  let current = payload;

  for (let i = 0; i < 3; i += 1) {
    if (typeof current !== "string") {
      break;
    }

    const trimmed = current.trim();
    if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) {
      break;
    }

    try {
      current = JSON.parse(trimmed);
    } catch {
      break;
    }
  }

  return current;
}

export function getBaseResponseError(parsed, fallback = "İşlem başarısız.") {
  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
    return null;
  }

  const responseCode = parsed.responseCode ?? parsed.ResponseCode;
  if (responseCode != null && Number(responseCode) !== 200) {
    const messages = parsed.messages ?? parsed.Messages;
    return (
      (Array.isArray(messages) && messages[0]) ||
      parsed.message ||
      parsed.Message ||
      fallback
    );
  }

  const success = parsed.success ?? parsed.Success;
  if (success === false) {
    return parsed.message || parsed.Message || fallback;
  }

  return null;
}

export function extractBaseResponseData(parsed) {
  if (parsed == null) {
    return null;
  }

  if (typeof parsed !== "object" || Array.isArray(parsed)) {
    return parsed;
  }

  if (
    parsed.success !== undefined ||
    parsed.Success !== undefined ||
    parsed.data !== undefined ||
    parsed.Data !== undefined
  ) {
    return parsed.data ?? parsed.Data ?? null;
  }

  return parsed.data ?? parsed.Data ?? null;
}
